import r from "./index86.mjs";
import { useEffect as n } from "react";
import { StorageKey as c } from "./index50.mjs";
import { useStorage as S } from "./index51.mjs";
import { CookiesEnum as o } from "./index49.mjs";
const m = (e) => {
  const t = r.get(o.PublicUserId);
  return `${c.SessionStorePrefix}${t ?? "shared"}:${e}`;
}, f = (e) => r.get(o.BrowserSessionActiveId) === e.toString(), I = (e, t) => {
  n(() => {
    e && r.set(o.PublicUserId, [e, t].filter(Boolean).join("_"), {
      path: "/",
      secure: !0,
      sameSite: "strict"
    });
  }, [e, t]);
}, P = (e, t = {}) => {
  const s = r.get(o.PublicUserId) ?? "shared", i = S(m(e), t);
  return n(() => {
    f(s) || (i.removeByPrefix(c.SessionStorePrefix), r.set(o.BrowserSessionActiveId, s.toString(), {
      sameSite: "strict",
      path: "/"
    }));
  }, [s, i.removeByPrefix]), i;
};
export {
  m as getSessionStoreKey,
  I as useExtendSessionId,
  P as useSessionStore
};
